var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'day',
    { 'is-drag-enter': _setup.isDragEnter, 'is-dragging': _setup.isDragging },
  ],style:({
    '--start-day': _vm.name + '-start',
  })},[_vm._t("default"),_c('div',{class:['day-shadow', { 'is-today': _vm.current, 'is-header': _vm.isHeader }],on:{"drop":_setup.onDrop,"dragenter":[_setup.toggleDragEnter,function($event){$event.preventDefault();}],"dragleave":_setup.toggleDragEnter,"dragover":function($event){$event.preventDefault();}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }